<template>
    <div
        class="col p-0"
        :data-cy="'paymentLinesTable'"
    >
        <card
            class="no-border-card"
            body-classes="p-0"
            footer-classes="pb-2"
        >
            <div>
                <el-table
                    :data="queriedData"
                    row-key="deadlineDate"
                    header-row-class-name="thead-light"
                >
                    <el-table-column
                        v-for="column in tableColumns"
                        :key="column.label"
                        v-bind="column"
                        :formatter="column.formatter"
                    />
                </el-table>
            </div>
        </card>
    </div>
</template>

<script>
import { Option, Select, Table, TableColumn } from "element-ui";
import clientPaginationMixin from "@/views/Mixins/clientPaginationMixin";
import BaseButton from "@/components/BaseButton";
import Modal from "@/components/Modal";
import formatterMixins from "@/mixins/formatterMixins";

export default {
    name: "PaymentLinesTable",
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    mixins: [
        clientPaginationMixin,
        BaseButton,
        Modal
    ],
    props: {
        tableData: {
            type: Array
        },
        currency: {
            type: String
        }
    },
    data() {
        return {
            tableColumns: [
                {
                    prop: "type",
                    label: this.$t("tables.column.paymentType"),
                    minWidth: 120,
                    sortable: true,
                    formatter: (row) => {
                        return row.type + ' | ' + this.$t(`choices.fiscalDocument.payment.type.${row.type}`);
                    }
                },
                {
                    prop: "mode",
                    label: this.$t("tables.column.paymentMode"),
                    minWidth: 120,
                    sortable: true,
                    formatter: (row) => {
                        return row.mode + ' | ' + this.$t(`choices.fiscalDocument.payment.mode.${row.mode}`);
                    }
                },
                {
                    prop: "iban",
                    label: this.$t("tables.column.iban"),
                    minWidth: 160,
                    sortable: true,
                },
                {
                    prop: "amount",
                    label: this.$t("tables.column.amount"),
                    minWidth: 80,
                    sortable: true,
                    formatter: (row) => {
                        return formatterMixins.methods.formatCurrency(this.currency, row.amount);
                    }
                },
                {
                    prop: "deadlineDate",
                    label: this.$t('tables.column.paymentDeadlineDate'),
                    minWidth: 80,
                    sortable: true,
                    formatter: (row) => {
                        return row.deadlineDate ? formatterMixins.methods.formatBackendDate(new Date(row.deadlineDate)) : '';
                    }
                },
            ],
        };
    },
};
</script>
